<template>
  <CounterTimer />
</template>

<script>
import CounterTimer from "./components/Counter.vue";

export default {
  name: "App",
  components: {
    CounterTimer,
  },
};
</script>

<style></style>
